module.exports = __webpack_public_path__ + "static/img/invite_cover.b4bb9e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fx/invite_cover.png
// module id = a78B
// module chunks = 0